async function copier(txt, onCopy=undefined) {
    await navigator.clipboard.writeText(txt)
    onCopy && onCopy(txt)
}

export default copier